import { Component, Input } from '@angular/core';
import { SearchCriteria } from '../models/search-criteria';

@Component({
  selector: 'irar-search-criteria',
  template: `
  <div>
    <b>{{resultCount}}</b> documents met the following search criteria:
  </div>
  <br/>
  <ul>
    <li>Farm Name: <b>{{farms}}</b></li>
  	<li>Site Name: <b>{{sites}}</b></li>
  	<li>Document Title: <b>{{documentTitle}}</b></li>
  	<li>Document Date: <b>{{criteria.startDate | date:'MMMM yyyy'}}</b> TO <b>{{criteria.endDate | date:'MMMM yyyy'}}</b></li>
  </ul>
  `
})
export class SearchCriteriaComponent {
  @Input() criteria: SearchCriteria;
  @Input() resultCount: number;

  get farms() {
    if (!this.criteria || !this.criteria.farm) { return ''; }
    return this.criteria.farm.join(', ');
  }

  get sites() {
    if (!this.criteria || !this.criteria.site) { return ''; }
    return this.criteria.site.join(', ');
  }

  get authors() {
    if (!this.criteria || !this.criteria.author) { return ''; }
    return this.criteria.author.join(', ');
  }

  get documentTitle() {
    if (!this.criteria) { return ''; }
    return this.criteria.title;
  }

  get author() {
    if (!this.criteria) { return ''; }
    return this.criteria.author;
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/search-criteria.ts